// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1HourSchema } from './v1/hourSchema';
import { v1HoursUpdateSchema } from './v1/hours/updateSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const updateHourPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Time entry ID"),
});

export const updateHourHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Time entry updated
 */
export const updateHour200Schema = z.lazy(() => v1HourSchema);

/**
 * @description Unauthorized
 */
export const updateHour401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Time entry not found
 */
export const updateHour404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Validation errors
 */
export const updateHour422Schema = z.lazy(() => v1ValidationErrorSchema);

export const updateHourMutationRequestSchema = z.lazy(() => v1HoursUpdateSchema);

export const updateHourMutationResponseSchema = z.lazy(() => updateHour200Schema);
